import { clear, el } from "../utils/dom.ts";

export interface PanelOptions {
  id: string;
  title: string;
  subtitle?: string;
}

// Base panel: header (title + optional status badge slot) + content area.
export class Panel {
  readonly id: string;
  readonly el: HTMLElement;
  protected readonly content: HTMLElement;
  protected readonly badgeSlot: HTMLElement;
  private readonly titleEl: HTMLElement;

  constructor(opts: PanelOptions) {
    this.id = opts.id;
    this.titleEl = el("span", { className: "panel-title" }, [opts.title]);
    this.badgeSlot = el("span", { className: "panel-badge-slot" });
    const header = el("div", { className: "panel-header" }, [this.titleEl, this.badgeSlot]);
    this.content = el("div", { className: "panel-content" });
    this.el = el("section", { className: "panel", "data-panel": opts.id }, [header, this.content]);
    if (opts.subtitle) {
      this.titleEl.append(el("span", { className: "panel-subtitle" }, [opts.subtitle]));
    }
  }

  protected setContent(...nodes: (Node | string)[]): void {
    clear(this.content);
    for (const n of nodes) this.content.append(typeof n === "string" ? document.createTextNode(n) : n);
  }

  protected setLoading(): void {
    this.setContent(el("div", { className: "panel-loading" }, ["Đang tải…"]));
  }

  protected setError(msg = "Không tải được dữ liệu"): void {
    this.setContent(el("div", { className: "panel-error" }, [msg]));
  }

  setBadge(node: Node | null): void {
    clear(this.badgeSlot);
    if (node) this.badgeSlot.append(node);
  }
}
